import React from "react";
import { useGlobalContext } from "./context/globalContext";

const Details = ({ project }) => {
  const { handleShowModal } = useGlobalContext();

  const highlights1 = [
    "A Marvellous Gym with Breathtaking Views ",
    "Spacious Living Areas with Private Decks ",
    "A Glittering Club House 220 Metres above Sea Level ",
  ];
  const highlights2 = [
    "Connectivity to MTHL and Orange Tunnel ",
    "Proximity to Metro Line 11 and Sewri-Worli Connector ",
    "Grand Entrance Lobby with Designer Finishes",
  ];
  return (
    <section class="section shadow-sm lazyloaded" id="overview">
      <div class="over1">
        <h1 class="d-block section-heading color-primary text-capitalize">
          {project} - Overview
        </h1>

        <p>
          Welcome to L&T Gateway Sewri, an architectural masterpiece nestled on
          Mumbai's eastern seafront. Offering luxurious 3, 4, and 4.5 BHK
          residences, this project seamlessly blends modern design with
          unparalleled comfort. Each home boasts private decks with harbor sea
          views, redefining luxury living in Mumbai. <br /> Enjoy over 40,000
          sq. ft. of world-class amenities, including a sky club 220 meters
          above sea level, providing a lifestyle of opulence amidst the clouds.
          Strategically located in Sewri, residents benefit from excellent
          connectivity to major business hubs, educational institutions, and
          entertainment centers.
        </p>
      </div>
      <center>
        <h3 style={{ fontSize: "1.2rem" }} className="mt-3">
          {project} - Highlights
        </h3>
      </center>

      <div
        className="mr0 aos-init aos-animate mt-2"
        data-aos="fade-up"
        data-aos-delay="600"
        data-aos-duration="3000"
      >
        <div className="row">
          <div className="col-lg-6 col-md-6 col-sm-6">
            {/* <ul className="whybuy text-capitalize">
              <li>
                <span>Spacious 1 & 2 BHK Residences</span>
              </li>
              <li>
                <span>
                  Iconic high-rise 46-Storey Towers with premium architecture
                </span>
              </li>
              <li>
                <span>
                  Unmatched Investment Potential with high appreciation value
                </span>
              </li>
            </ul> */}

            <ul className="whybuy text-capitalize">
              {highlights1.map((highlight, index) => (
                <li key={index}>
                  <span>{highlight}</span>
                </li>
              ))}
            </ul>
          </div>
          <div className="col-lg-6 col-md-6 col-sm-6">
            {/* <ul className="whybuy">
              <li>
                <span>Smart layouts for modern families</span>
              </li>
              <li>
                <span>
                  Seamless Connectivity to EEH, Railway Station & Malls
                </span>
              </li>
              <li>
                <span>
                  Marvellous Amenities like Clubhouse, Swimming Pool & More
                </span>
              </li>
            </ul> */}
            <ul className="whybuy text-capitalize">
              {highlights2.map((highlight, index) => (
                <li key={index}>
                  <span>{highlight}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
      <button
        class="chat-btn btn btn-info micro-form-btn effetMoveGradient enqModal download_brochure"
        onClick={handleShowModal}
      >
        <span class="d-inline-block mi mi-download mr-1 animated slideInDown infinite"></span>{" "}
        Download Brochure
      </button>
    </section>
  );
};

export default Details;
